<section class="offering-related">
  <div class="offering-related-header">
    <h1 class="ui-heading-1-bold">{{ extraSection() }}</h1>
  </div>

  <div class="offering-related-content">
    @for (s of similarOfferings(); track s) {
      <inexp-offering-card
        [displayName]="s.content?.displayName"
        [offeringImage]="s.content?.offeringImage"
        [description]="s.content?.description"
        [slug]="s?.slug"
      ></inexp-offering-card>
    }
  </div>
</section>
